/*
Generated time: July 12, 2025 11:52
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
let SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger",
    SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen",
    SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "animate--zoom-in",
    SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";
function onIntersection(e, r) {
    e.forEach((e, t) => {
        var i;
        e.isIntersecting
            ? ((i = e.target).classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME) &&
                  (i.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME), i.hasAttribute("data-cascade")) &&
                  i.setAttribute("style", `--animation-order: ${t};`),
              r.unobserve(i))
            : (e.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),
              e.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME));
    });
}
function initializeScrollAnimationTrigger(e = document, t = !1) {
    e = Array.from(e.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
    if (0 !== e.length)
        if (t)
            e.forEach((e) => {
                e.classList.add("scroll-trigger--design-mode");
            });
        else {
            let t = new IntersectionObserver(onIntersection, { rootMargin: "0px 0px -50px 0px" });
            e.forEach((e) => t.observe(e));
        }
}
function initializeScrollZoomAnimationTrigger() {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        var e = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
        if (0 !== e.length)
            e.forEach((e) => {
                let t = !1;
                new IntersectionObserver((e) => {
                    e.forEach((e) => {
                        t = e.isIntersecting;
                    });
                }).observe(e),
                    e.style.setProperty("--zoom-in-ratio", 1 + 0.002 * percentageSeen(e)),
                    window.addEventListener(
                        "scroll",
                        throttle(() => {
                            t && e.style.setProperty("--zoom-in-ratio", 1 + 0.002 * percentageSeen(e));
                        }),
                        { passive: !0 }
                    );
            });
    }
}
function percentageSeen(e) {
    var t = window.innerHeight,
        i = window.scrollY,
        r = e.getBoundingClientRect().top + i,
        e = e.offsetHeight;
    return i + t < r ? 0 : r + e < i ? 100 : Math.round((i + t - r) / ((t + e) / 100));
}
window.addEventListener("DOMContentLoaded", () => {
    initializeScrollAnimationTrigger(), initializeScrollZoomAnimationTrigger();
}),
    Shopify.designMode &&
        (document.addEventListener("shopify:section:load", (e) => initializeScrollAnimationTrigger(e.target, !0)),
        document.addEventListener("shopify:section:reorder", () => initializeScrollAnimationTrigger(document, !0)));
